import React, { memo, forwardRef } from "react";
const SvgSummation = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M3.076 8.617A1 1 0 014 8h12a1 1 0 110 2H6.414l5.293 5.293a1 1 0 010 1.414L6.414 22H15.5a1 1 0 110 2H4a1 1 0 01-.707-1.707L9.586 16 3.293 9.707a1 1 0 01-.217-1.09z"
        clipRule="evenodd"
      />
      <rect width={10} height={16} x={20} y={8} fill="#DBDBDB" rx={2} />
      <rect
        width={4}
        height={8}
        x={6}
        y={6}
        fill="#DBDBDB"
        rx={1}
        transform="rotate(-90 6 6)"
      />
      <rect
        width={4}
        height={8}
        x={6}
        y={30}
        fill="#DBDBDB"
        rx={1}
        transform="rotate(-90 6 30)"
      />
    </svg>
  );
});
SvgSummation.displayName = "SvgSummation";
const MemoForwardRef = memo(SvgSummation);
export default MemoForwardRef;
